import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface EmptyStateProps {
  /** Icon node (e.g. <Icon name="phone" size={24} />). */
  icon?: ReactNode;
  iconTone?: 'primary' | 'danger' | 'neutral';
  title: ReactNode;
  description?: ReactNode;
  /** Primary + secondary actions. */
  actions?: ReactNode;
  /** Drop the card border/background (for use inside another card). */
  borderless?: boolean;
  className?: string;
}

/** Meaningful empty / error state: icon + one line + action (brief §7.1). */
export function EmptyState({ icon, iconTone = 'primary', title, description, actions, borderless, className }: EmptyStateProps) {
  return (
    <div className={cx('tc-empty', borderless && 'tc-empty--borderless', className)}>
      {icon && (
        <div className={cx('tc-empty__icon', iconTone !== 'primary' && `tc-empty__icon--${iconTone}`)}>{icon}</div>
      )}
      <div className="tc-empty__title">{title}</div>
      {description && <div className="tc-empty__desc">{description}</div>}
      {actions && <div className="tc-empty__actions">{actions}</div>}
    </div>
  );
}
